module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/img_form-c75dca1db296d9ed084203dd466b0a28.png";